import React, { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import { useSelector } from "react-redux";
import { FaFileAlt, FaUserCheck, FaChartBar, FaListUl, FaMapMarkerAlt } from "react-icons/fa";
import { consultarAcceso } from "../../registro/registro";
import {
  VENTAS_SUSPENDIDAS,
  MENSAJE_VENTAS_SUSPENDIDAS,
} from "../../config/mantenimiento";
import {
  DashboardContainer,
  DashboardTitle,
  CardsGrid,
  DashboardCard,
  CardIcon,
  CardTitle,
  CardDescription,
} from "./dashboardStyles";

const Dashboard = () => {
  const navigate = useNavigate();
  const currentUser = useSelector((state) => state.user.currentUser);
  const token = currentUser?.data?.token || false;

  // Acceso al panel comercial: se consulta al backend. Si no responde, el
  // dashboard funciona igual, sin la tarjeta del panel.
  const [panel, setPanel] = useState(false);

  useEffect(() => {
    if (!token) navigate("/");
  }, [token, navigate]);

  useEffect(() => {
    if (!token) return;
    let vigente = true;
    consultarAcceso().then((r) => {
      if (vigente) setPanel(Boolean(r?.panel));
    });
    return () => {
      vigente = false;
    };
  }, [token]);

  const handleKeyDown = (e, path) => {
    if (e.key === "Enter" || e.key === " ") {
      e.preventDefault();
      navigate(path);
    }
  };

  return (
    <DashboardContainer>
      <DashboardTitle>
        Hola{currentUser?.usuario ? `, ${currentUser.usuario}` : ""}
        <span>¿Qué querés hacer hoy?</span>
      </DashboardTitle>
      <CardsGrid>
        {VENTAS_SUSPENDIDAS ? (
          <DashboardCard
            aria-disabled="true"
            style={{ opacity: 0.55, cursor: "not-allowed" }}
            title={MENSAJE_VENTAS_SUSPENDIDAS}
          >
            <CardIcon>
              <FaFileAlt />
            </CardIcon>
            <CardTitle>Cargar venta</CardTitle>
            <CardDescription>{MENSAJE_VENTAS_SUSPENDIDAS}</CardDescription>
          </DashboardCard>
        ) : (
          <DashboardCard
            onClick={() => navigate("/formulario")}
            onKeyDown={(e) => handleKeyDown(e, "/formulario")}
            role="button"
            tabIndex={0}
          >
            <CardIcon>
              <FaFileAlt />
            </CardIcon>
            <CardTitle>Cargar venta</CardTitle>
            <CardDescription>
              Registrar el alta de un nuevo cliente y configurar su plan
              comercial.
            </CardDescription>
          </DashboardCard>
        )}

        <DashboardCard
          onClick={() => navigate("/solicitud-servicio")}
          onKeyDown={(e) => handleKeyDown(e, "/solicitud-servicio")}
          role="button"
          tabIndex={0}
        >
          <CardIcon>
            <FaMapMarkerAlt />
          </CardIcon>
          <CardTitle>Solicitud de servicio</CardTitle>
          <CardDescription>
            Registrar el interés de un cliente en una zona donde todavía no hay
            servicio.
          </CardDescription>
        </DashboardCard>

        <DashboardCard
          onClick={() => navigate("/mis-ventas")}
          onKeyDown={(e) => handleKeyDown(e, "/mis-ventas")}
          role="button"
          tabIndex={0}
        >
          <CardIcon>
            <FaListUl />
          </CardIcon>
          <CardTitle>Mis ventas</CardTitle>
          <CardDescription>
            Ver las últimas ventas que cargaste (con sus números de cliente) y
            tus solicitudes de servicio.
          </CardDescription>
        </DashboardCard>

        <DashboardCard
          onClick={() => navigate("/estado-cliente")}
          onKeyDown={(e) => handleKeyDown(e, "/estado-cliente")}
          role="button"
          tabIndex={0}
        >
          <CardIcon>
            <FaUserCheck />
          </CardIcon>
          <CardTitle>Estado de cliente</CardTitle>
          <CardDescription>
            Consultar el estado y servicios de un cliente existente.
          </CardDescription>
        </DashboardCard>
        {panel && (
          <DashboardCard
            onClick={() => navigate("/panel")}
            onKeyDown={(e) => handleKeyDown(e, "/panel")}
            role="button"
            tabIndex={0}
          >
            <CardIcon>
              <FaChartBar />
            </CardIcon>
            <CardTitle>Panel comercial</CardTitle>
            <CardDescription>
              Ver las ventas cargadas y las solicitudes de servicio.
            </CardDescription>
          </DashboardCard>
        )}
      </CardsGrid>
    </DashboardContainer>
  );
};

export default Dashboard;
